export default "__VITE_ASSET__acc88dc3__"